import React, { useMemo } from 'react';

import { useDateTimePicker, useDatePicker } from 'components/hooks/useDatePicker';
import DateField, { DueDateStyles } from 'screens/common/sidepanel/DetailSection/DateField';
import styled, { css } from 'styled-components';

import { getCheckInDueDateColor } from 'services/helpers/task';

export default function DateComp({
  tooltip,
  startDateTime,
  endDateTime,
  color = null, // color override from outside.
  onDateTimeChange = null,
  editable = true,
  onlyDateChange = false,
  isCrossed = false,
}) {
  const openDateTimePicker = useDateTimePicker(onDateTimeChange);
  const openDatePicker = useDatePicker(onDateTimeChange);
  const onClickHandler = (e) => {
    if (editable) {
      e.stopPropagation();
      if (onlyDateChange) {
        openDatePicker({ initialDate: startDateTime });
      } else {
        openDateTimePicker({ initialDate: startDateTime, endDate: endDateTime });
      }
    }
  };

  const borderColor = useMemo(() => getCheckInDueDateColor(startDateTime), [startDateTime]);

  return (
    <StyledDateField
      borderColor={color || borderColor}
      onClick={onClickHandler}
      clickable={editable}
      tooltip={tooltip}
      isCrossed={isCrossed}
    >
      {startDateTime && <DateField.DatePresentDisplay date={startDateTime} />}
    </StyledDateField>
  );
}

const StyledDateField = styled(DateField)`
  ${DueDateStyles};

  ${(props) =>
    props.isCrossed &&
    css`
      text-decoration: line-through;
    `}
`;
